import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-center text-sm" data-id="element-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-21">
        <p className="mb-4" data-id="element-22">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="mb-6" data-id="element-23">
          Los resultados pueden variar de persona a persona. La información
          proporcionada no pretende sustituir el consejo médico profesional.
        </p>
        <div className="flex justify-center space-x-6" data-id="element-24">
          <a href="#" className="hover:text-white transition-colors" data-id="element-25">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-26">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-27">
            Contacto
          </a>
        </div>
        <p className="mt-8" data-id="element-28">
          &copy; {new Date().getFullYear()} Protocolo de Reinicio de Cortisol.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}